import { IconCheck } from "components/icons/IconCheck";
import { useMprcTheme } from "components/MprcThemeProvider";
import * as React from "react";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";

export const IconButtonSave: React.FC<MprcIconButtonProps> = ({ title, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonSave.title;

    return (
        <MprcIconButton
            {...rest}
            title={lTitle}
        >
            <IconCheck fixedWidth />
        </MprcIconButton>
    );
};
